import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import { ResponseData } from "../../nest-responses";
import { ResponseClaimGetTypeDto } from "../dto/sf-claim-request.dto";

@Injectable()
export class SfClaimRequestNestApi {
  private readonly service: string = '';
  private readonly model: string = 'SFClaimRequests';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getType(empId: any): Observable<ResponseData<ResponseClaimGetTypeDto>> {
    // console.log(`masuk get type`, payload);
    const method: string = 'GET';
    const func: string = 'getType';
    const params: any = {};
    const urlParams: any =  { empId };
    const body: any = {};
    // if (typeof payload.empId !== 'undefined' && payload.empId !== null) urlParams = payload.empId;
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseClaimGetTypeDto>>(method, url, params, urlParams, body);
  }

  public getCurrency(): Observable<ResponseData<ResponseClaimGetTypeDto>> {
    const method: string = 'GET';
    const func: string = 'getCurrency';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseClaimGetTypeDto>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-claim-request.api.ts